import { useTinyHost } from "@tiny/host-contract";
import * as React from "react";
import { Box, Checkbox, Link } from "@tiny/components";
import ShortRight from "@tiny/icons/generated/ShortRight";
import { SegmentCardProps } from "../PredefinedSegments.types";
import { CardName } from "./CardName";
import { CardDescription } from "./CardDescription";

function SegmentCard({
  id,
  name,
  description,
  index,
  segmentType,
  isSelected,
  onSelect,
  segment,
  selectionDisabled,
}: SegmentCardProps) {
  const { navigate } = useTinyHost();
  const getBgColor = () => {
    // TODO: in v2 use the system colors
    if (segmentType === "PREDEFINED_RECOMMENDED") {
      return "white";
    } else if (segmentType === "PREDEFINED_LIBRARY") {
      return "#EEE7F3";
    } else if (segmentType === "PREDEFINED_DELIVERY") {
      return "#F4EBEA";
    }
  };

  const [checked, setChecked] = React.useState(false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!selectionDisabled) {
      onSelect(segment, e.target.checked);
    }
  };

  const audienceLocation = {
    pathname: `/main/audience/segments/${segment.id}`,
    state: {
      backUrl: { pathname: location.pathname, search: location.search },
    },
  };

  return (
    <Box
      display="flex"
      p={4}
      alignItems="flex-start"
      style={{
        backgroundColor: getBgColor(),
      }}
      borderRadius="8px"
      minWidth={150}
    >
      {!selectionDisabled && (
        <Checkbox
          color="primary"
          value={checked}
          checked={isSelected}
          onChange={handleCheckboxChange}
          disabled={false}
          style={{
            marginRight: 2,
            marginLeft: -6,
            marginTop: -2.5,
          }}
        />
      )}
      <Box
        display="flex"
        justifyContent={"space-between"}
        flexDirection={"column"}
        height={"100%"}
      >
        <Box style={{ wordBreak: "break-word" }}>
          <CardName name={name} cardIndex={index} />
          <CardDescription description={description} />
        </Box>
        <Box alignSelf="flex-start" height={24}>
          <Link
            component={"button" as React.ElementType}
            onClick={() =>
              navigate.to(audienceLocation.pathname, {
                state: audienceLocation.state,
              })
            }
          >
            <ShortRight color="primary" />
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

export default SegmentCard;
